import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Importa el router
import './assets/styles.css';

createApp(App)
  .use(router)  // Usa el router
  .mount('#app');
